import { gql } from "@apollo/client";
import { useMutation, useQuery } from "@apollo/client/react";
import { useState } from "react";


import GetGeometryType from "./GetGeometryType.graphql";
import TagGeometryType from "./TagGeometryType.graphql";
import * as UI from "../../../../../modules/ui-kit";

export default function Tags(props) {
    const { id, revisionID } = props;
    const [busy, setBusy] = useState(false);

    const getGeometryType = useQuery(
        gql(GetGeometryType),
        {
            variables: {
                id,
                revisionID,
            },
        },
    );

    const [tagGeometryType] = useMutation(
        gql(TagGeometryType),
        {
            // Publishing moves the "public" tag off whichever revision held it,
            // so the whole version list is stale, not just this revision.
            awaitRefetchQueries: true,
            refetchQueries: [
                gql(GetGeometryType),
                "ListGeometryTypeRevisions",
            ],
            variables: {
                id,
                revisionID,
                tag: "public",
            },
        },
    );

    if (getGeometryType.loading || getGeometryType.error) return null;

    const isPublic = getGeometryType.data?.geometryType?.revision?.tags?.includes?.("public");

    async function toggle() {
        setBusy(true);
        try {
            if (isPublic) {
                await tagGeometryType({ variables: { delete: true } });
            } else {
                await tagGeometryType();
            }
        } finally {
            setBusy(false);
        }
    }

    return (
        <UI.Button
            $appearance={ isPublic ? "danger" : "primary" }
            $size="small"
            disabled={ busy }
            onClick={ toggle }
        >
            { busy ? (isPublic ? "Unpublishing…" : "Publishing…") : (isPublic ? "Unpublish" : "Publish") }
        </UI.Button>
    );
}
